const formHelpers = require("../components/formErrors.js");
const utils = require("../components/utils");
const formContactUs = $("form.contactUs");
const recaptcha = require("google/recaptcha");
const selectSubject = formContactUs.find("select.contact-us-subject");
const orderSubtopic = formContactUs.find("select.contact-us-subsubject");
const $orderSubtopicSelect = $("select.contact-us-subsubject");
const topic = formContactUs.find("select.contact-us-topic");
const newsletterAgreement = $("#contact-accept-newsletter-subscription");
const focusField = require("../components/focusField");
const contactAdditionalData = $(".contactAdditionalData");
const subtopicMessage = $(".subtopic-message");

/**
* Resets the contact additional fields
*/
function resetContactAdditionalFields() {
    var $additionalDataFields = contactAdditionalData.find("select");
    var $currentField = null;
    $additionalDataFields.each(function () {
        $currentField = $(this);
        $currentField.val($currentField.find("option[selected]").removeAttr("selected"));
        $currentField.val($currentField.find("option:first").attr("selected", "selected").trigger("change"));
    });
}

/**
* Sets the required attribute of the given fields
* @param {Array} fields - array of fields to set required attribute
* @param {boolean} isRequired - whether the fields should be required
*/
function setFieldsRequired(fields, isRequired) {
    fields.forEach(function (field) {
        $(field).prop("required", isRequired);
    });
}

/**
 * Populates the topic dropdown based on the selected subject.
 * @param {jQuery} $triggerSelect - the select element that triggers the update
 * @param {string} selectedValue - the selected subject/subsubject value
 */
function updateTopicDropdown($triggerSelect, selectedValue) {
    const destinationDropdown = formContactUs.find("select.contact-us-topic");
    destinationDropdown.empty();

    // Reset subtopic message
    subtopicMessage.addClass("d-none");
    orderSubtopic.prop("required", false);
    $orderSubtopicSelect.removeClass("required-contact");

    // Clone matching topic items
    formContactUs
        .find(`select.contact-topic-${selectedValue}`)
        .children()
        .clone(true)
        .appendTo(destinationDropdown);

    // Mark order number required if needed
    if ($triggerSelect.find(":selected").attr("data-order")) {
        formContactUs.find("input#contact-order-number").addClass("required");
    }

    // Reinitialize Select2
    destinationDropdown.select2({ minimumResultsForSearch: -1 });

    // Highlight and emit event if more than one option exists
    if ($(".form-control.contact-us-topic option").length > 1) {
        const $parentForm = $triggerSelect.closest("form");
        $parentForm
            .find(".form-group.contact-us-topic .select2-selection--single")
            .addClass("change-bg");
        $parentForm.trigger("topicDropdownChanged");
    }

    utils.updateLabelByComboBox($("#contact-topic"));
}

module.exports = {
    updateContactSubjectLabelledBy: function () {
        utils.updateLabelByComboBox($("#contact-subject"));
    },

    showTopicDropdown: function () {
        selectSubject.on("change", function (e, isInit) {
            e.preventDefault();
            const selectedValue = selectSubject.val();
            const $subSubject = $(".contact-us-subsubject");

            // Show/Hide subsubject dropdown based on data-order
            const isOrder = selectSubject.find(":selected").attr("data-order") === "order";
            // Show or hide the sub-subject dropdown
            $subSubject.toggleClass("d-none", !isOrder);
            // Set required attribute based on context
            orderSubtopic.prop("required", isOrder);
            $orderSubtopicSelect.toggleClass("required-contact", isOrder);
            // Prevent reset on pageload due to token autocomplete
            if (!isInit && isOrder) {
                $subSubject.val(null).trigger("change");
            }

            updateTopicDropdown(selectSubject, selectedValue);
        });

        if (selectSubject.val()) {
            selectSubject.trigger("change", true);
        }
    },

    showSubTopicDropdown: function () {
        orderSubtopic.on("change", function (e) {
            e.preventDefault();
            const selectedValue = orderSubtopic.val();

            // Keep main subject value in sync
            $("#order-subject").val(String(selectedValue));

            updateTopicDropdown(orderSubtopic, selectedValue);
        });

        if (orderSubtopic.val()) {
            orderSubtopic.trigger("change");
        }
    },

    updateTopicMessage: function () {
        topic.on("change", function () {
            var selectedOption = $(this).find(":selected");
            var message = selectedOption.data("reason-message") || "";

            // Update the message text
            subtopicMessage.text(message);

            // Toggle visibility
            if (message.trim() === "") {
                subtopicMessage.addClass("d-none");
            } else {
                subtopicMessage.removeClass("d-none");
            }
        });
    },

    toggleAgreementFields: function () {
        // Reset checkmark on page load
        if (newsletterAgreement.is(":checked")) {
            newsletterAgreement.trigger("click");
        }
        // Reset additional fields on page load
        resetContactAdditionalFields();

        // Toggle additional fields on checkmark change event
        newsletterAgreement.on("change", function () {
            const isChecked = newsletterAgreement.is(":checked");
            const requiredFields = ["#register-day", "#register-month", "#register-year", "#countryOfResidence"];

            if (isChecked) {
                contactAdditionalData.removeClass("d-none");
                setFieldsRequired(requiredFields, true);
            } else {
                resetContactAdditionalFields();
                contactAdditionalData.addClass("d-none").find(".is-invalid").removeClass("is-invalid");
                setFieldsRequired(requiredFields, false);
            }
        });
    },
    subscribeContact: function () {
        formContactUs.submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr("action");
            const sourceDetail = form.parent().data("source-detail");
            $.spinner().start();
            var $serverErrorField = $(".contact-us-server-error");
            utils.setBirthdateInput(".register-birthdate");
            $serverErrorField.empty();

            recaptcha.setToken({ formSelector: "form.contactUs" }).then(function () {
                // Append the sourceDetail to the serialized form data
                const formData = sourceDetail ? form.serialize() + "&sourceDetail=" + encodeURIComponent(sourceDetail) : form.serialize();

                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: formData,
                    success: function (data) {
                        form.spinner().stop();
                        if (!data.success) {
                            formHelpers.loadFormErrors(form, data);
                            $.spinner().stop();
                            focusField($(".is-invalid").first());
                        } else {
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (err) {
                        form.spinner().stop();
                        const message = err.responseJSON.message;
                        if (!message) {
                            return;
                        }
                        $serverErrorField.append("<p>" + message + "</p>");
                        focusField($serverErrorField);
                    }
                });
            });
            return false;
        });
    },

    openContactModal: function () {
        /**
        * Handles the click event on elements with the class 'open-contact-modal' within the 'formContactUs' form.
        * Updates the modal title in the contact modal to reflect the currently selected contact topic.
        */
        formContactUs.on("click", ".open-contact-modal", function () {
            const subject = formContactUs.find("select.contact-us-topic option:selected").text().trim();

            formContactUs.find("#contactModal .modal-title").text(subject);
        });
    },

    triggerContactForm: function () {
        /**
        * Handles the click event on the contact form's submit button.
        * Hides the contact modal and triggers the form submission.
        */
        formContactUs.on("click", ".submit-contact-form", function () {
            $("#contactModal").modal("hide");
            formContactUs.trigger("submit");
        });
    },

    focusErrorField: function () {
        $(window).on("loadedFormErrors", function () {
            focusField($(".is-invalid").first());
        });
    }
};
